import http from '@/requests/http'
import appConfig from '@/config/app'

class CallStatistics {
  static findAll (params) {
    return http.post('agents/call-statistics', params)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/agents/call-statistics/export?${URLparams}`, '_blank')
  }
}

export default CallStatistics
